import { BiLogger } from './services/biLogger';
import { create as createFedopsLogger } from '@wix/fedops-logger';
import { ClientOffering } from './services/client-offering';

export const biLogger: BiLogger = new BiLogger();
export const fedopsLogger = createFedopsLogger('ascend-package-picker');

export let data: ClientOffering;

export const createData = (offering: any, experiments?: any) => {
  const generatedData = new ClientOffering({ ...offering, experiments });
  data = generatedData;
  return data;
};
